var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15688",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.350586,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15688)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.61538 21.3505C5.15513 21.3505 4.77083 21.1964 4.4625 20.888C4.15417 20.5797 4 20.1954 4 19.7352V6.9659C4 6.50565 4.15417 6.12136 4.4625 5.81303C4.77083 5.50469 5.15513 5.35053 5.61538 5.35053H7.3846V3.11975H8.46152V5.35053H15.6154V3.11975H16.6154V5.35053H18.3846C18.8449 5.35053 19.2292 5.50469 19.5375 5.81303C19.8458 6.12136 20 6.50565 20 6.9659V12.1967H19V10.9659H5V19.7352C5 19.889 5.0641 20.03 5.1923 20.1582C5.32052 20.2864 5.46154 20.3505 5.61538 20.3505H10.2308V21.3505H5.61538ZM20.2789 16.139L18.8462 14.7063L19.5712 13.9813C19.6776 13.8749 19.7955 13.8217 19.925 13.8217C20.0545 13.8217 20.1725 13.8749 20.2789 13.9813L21.0039 14.7063C21.1103 14.8127 21.1635 14.9307 21.1635 15.0602C21.1635 15.1896 21.1103 15.3076 21.0039 15.414L20.2789 16.139ZM13 21.9852V20.5525L18.1462 15.4063L19.5788 16.839L14.4327 21.9852H13ZM5 9.9659H19V6.9659C19 6.81207 18.9359 6.67104 18.8077 6.54283C18.6795 6.41463 18.5385 6.35053 18.3846 6.35053H5.61538C5.46154 6.35053 5.32052 6.41463 5.1923 6.54283C5.0641 6.67104 5 6.81207 5 6.9659V9.9659Z",
    fill: "#B8B9BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.37a52b1c9a5d1a71908ef606b85c8e31.svg";
export { ForwardRef as ReactComponent };